import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  formStatuses: [
    { id: 0, name: 'Active' },
    { id: 1, name: 'Pending' },
    { id: 10, name: 'Submitted' },
    { id: 20, name: 'Closed' }
  ],
  submittedFormsQty: null
}

const mutations = {
  setSubmittedFormsQty (state, qty) {
    state.submittedFormsQty = qty
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  getSubmittedFormsQty ({ commit }) {
    Vue.axios.get('fcf-qty', { params: { status: 10 } })
      .then(response => {
        if (response.data) {
          commit('setSubmittedFormsQty', response.data.qty)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const getters = {
  getFormStatusName: (state) => (value) => {
    if (value === undefined) return
    const status = state.formStatuses.find(s => s.id === value)
    if (status === undefined) return
    return status.name
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
